import React, { useEffect, useId, useState } from "react";
import { Container, Stack } from "react-bootstrap";
import { getDailyHealthTreatmentsCountForConsignmentID } from "../../api/apiAccess";

const TreatmentOverview = ({ consignment, index, isStarted }) => {
    const componentId = useId()
    const [treatments, setTreatments] = useState("");
    const [treatmentsLatestDay, setTreatmentsLatestDay] = useState("-");
    const [treatmentsTotal, setTreatmentsTotal] = useState("-");

    useEffect(() => {
        if (consignment === undefined || isStarted === false) return;

        const fetchTreatments = async () => {
            let results = await getDailyHealthTreatmentsCountForConsignmentID(consignment.id);
            if (results?.status === 200) {
                setTreatments(results.data);
            }
        }

        fetchTreatments();
    }, [consignment, isStarted]);

    useEffect(() => {
        if (!isStarted) return;
        if (treatments === "") return;
        populateTreatmentData();
    }, [treatments]);

    const populateTreatmentData = () => {
        const totalHealthReports = (treatments ?? []).reduce(
            (sum, t) => sum + (t.numberOfHealthTreatments ?? 0),
            0
        );
        setTreatmentsTotal(totalHealthReports);

        const latestDayTreatmentCount = (treatments ?? []).reduce(
            (latest, t) =>
                t && (!latest || t.dayNumber > latest.dayNumber) ? t : latest,
            null
        )?.numberOfHealthTreatments ?? 0;
        setTreatmentsLatestDay(latestDayTreatmentCount);
    }

    return (
        <Container fluid key={`treatements_overview_${componentId}_${index}`} className="my-auto mx-0 px-auto">
            <Stack direction="vertical">
                <Stack direction="horizontal">
                    <Stack className="text-center" direction="vertical">
                        <div>{treatmentsLatestDay}</div>
                        <div className="field-label">Latest Report</div>
                    </Stack>
                    <Stack className="text-center" direction="vertical">
                        <div>{treatmentsTotal}</div>
                        <div className="field-label">Voyage</div>
                    </Stack>
                </Stack>
            </Stack>
        </Container>
    )
};

export default TreatmentOverview;